import { useEffect } from 'react';

// Diagnostic route: throws from inside the bundle so a deploy can be checked
// for working source maps on demand, instead of waiting for a real crash.
//
// The throw has to originate in bundled code to prove anything. An error typed
// into the browser console gets captured too, but its frames come from the
// eval context and show up as <anonymous> — that tests event delivery, not
// symbolication. Webpack module scope also means nothing here is reachable from
// `window`, so a route is the way in.
//
// Pass condition: the resulting Sentry event names this file and
// `throwFromBundledCode` rather than minified frames like `Hk`/`Fk`.
//
// Front-end counterpart to the backend's /admin/sentry/test-exception-handling.
// It lives in the parent-facing app on purpose: Sentry.init is only called in
// packs/index.js, so the admin-* packs are not instrumented at all.
const throwFromBundledCode = () => {
  throw new Error('TEST: front-end exception for source map verification');
};

const SentrySourceMapTest = () => {
  // Thrown from an effect rather than render: it reaches window.onerror, which
  // the SDK's global handler captures, and it fires once per mount.
  useEffect(() => {
    throwFromBundledCode();
  }, []);

  return null;
};

export default SentrySourceMapTest;
